import * as React from 'react';
import { classNames, validatePropType } from 'uitk-react-utils';
import styles from './uitk-badge.css';
import { UitkBadgeProgramThemes } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkBadgeProgram = function (props) {
    var _a, _b;
    var text = props.text, theme = props.theme, a11yText = props.a11yText, className = props.className, children = props.children;
    var sharedCssClassName = 'uitk-badge-base';
    var baseCssClassName = 'uitk-badge';
    var programCssClassName = "".concat(baseCssClassName, "-program");
    var hasTextAsChild = React.Children.toArray(children).some(function (child) { return typeof child === 'string'; });
    var standardBadgeClassNames = getClassNameList(sharedCssClassName, "".concat(sharedCssClassName, "-large"), (_a = {}, _a["".concat(sharedCssClassName, "-has-text")] = text, _a), (_b = {}, _b["".concat(sharedCssClassName, "-icon-only")] = !text && children && !hasTextAsChild, _b), "".concat(programCssClassName, "-").concat(validatePropType(theme, UitkBadgeProgramThemes) && theme), className);
    return (React.createElement("span", { className: standardBadgeClassNames },
        children,
        text && (React.createElement("span", { className: getClassNameList("".concat(sharedCssClassName, "-text")), "aria-hidden": !!a11yText }, text)),
        a11yText && React.createElement("span", { className: getClassNameList('is-visually-hidden') }, a11yText)));
};
UitkBadgeProgram.displayName = 'UitkBadgeProgram';

export { UitkBadgeProgram };
